import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/store';
import { isFieldUser } from '@/utils/roleHelpers';
import { env } from '@/config/env';

interface NonFieldUserRouteProps {
  children: React.ReactElement;
}

/**
 * Protected route wrapper for non-field user pages (admin, etc.)
 * Redirects field users (Driver, Monitor, SpStaff) to compliance-management
 */
const NonFieldUserRoute: React.FC<NonFieldUserRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);

  // Bypass guard when authentication is disabled (development mode)
  if (!env.authEnabled && !env.authorizationEnabled) {
    return children;
  }

  // If not authenticated, redirect to login (handled by AuthGuard)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If user is a field user, redirect to compliance-management
  if (user && isFieldUser(user.roles)) {
    return <Navigate to="/compliance-management" replace />;
  }

  // User is not a field user, render the protected component
  return children;
};

export default NonFieldUserRoute;
